import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../context/context";

const EnrollModal = () => {
  const { isOpenEnrollForm, setToggleEnrollForm, selectedCourse } =
    useContext(MyContext);

  const [formData, setFormData] = useState({
    studentName: "",
    phoneNumber: "",
    email: "",
    education: "",
    course: selectedCourse,
    state: "",
    agreed: false,
  });

  useEffect(() => {
    if (selectedCourse) {
      setFormData((prev) => ({
        ...prev,
        course: selectedCourse,
      }));

      setToggleEnrollForm(true);
    }
  }, [selectedCourse, setToggleEnrollForm]);

  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);

  // handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Validate all fields
  const validateForm = () => {
    let newErrors = {};

    if (!formData.studentName.trim())
      newErrors.studentName = "Enter your name.";
    if (!formData.phoneNumber.trim())
      newErrors.phoneNumber = "Enter your phone number.";
    if (!formData.email.trim()) newErrors.email = "Enter your email.";
    if (!formData.education.trim())
      newErrors.education = "Select your education.";
    if (!formData.agreed) newErrors.agreed = "You must agree to continue.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Submit button clicked
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_ADMIN_BASE_URL}/api/add-responses`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (result.success) {
        setShowConfirm(true);
      } else {
        alert(result.message || "Something went wrong");
      }
    } catch (e) {
      alert(e.message);
    }
  };

  // Confirm submission
  const confirmSubmit = () => {
    setShowConfirm(false);
    setSubmitStatus("success");

    // Reset after showing success
    setTimeout(() => {
      setToggleEnrollForm(false);
      setSubmitStatus("");
      setFormData({
        studentName: "",
        phoneNumber: "",
        email: "",
        education: "",
        agreed: false,
      });
    }, 1200);
  };

  return (
    <>
      {/* MODAL */}
      {isOpenEnrollForm && (
        <div className="modal-overlay">
          <div className="enroll-modal">
            {/* CLOSE BUTTON */}
            <button
              className="form-close-btn"
              onClick={() => {
                setToggleEnrollForm(false);
                setShowConfirm(false);
                setSubmitStatus("");
              }}
            >
              ✕
            </button>

            <h2 className="modal-title">Talk with Our Expert</h2>

            {/* Name */}
            <input
              className="input"
              name="studentName"
              placeholder="Student Name"
              value={formData.studentName}
              onChange={handleChange}
            />
            {errors.studentName && (
              <p className="error">{errors.studentName}</p>
            )}

            {/* Phone */}
            <input
              className="input"
              name="phoneNumber"
              placeholder="Phone Number"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
            {errors.phoneNumber && (
              <p className="error">{errors.phoneNumber}</p>
            )}

            {/* Email */}
            <input
              className="input"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <p className="error">{errors.email}</p>}

            {/* Education */}
            <select
              className="input"
              name="education"
              value={formData.education}
              onChange={handleChange}
            >
              <option value="">-- Select Education --</option>
              <option>10th</option>
              <option>Intermediate</option>
              <option>Diploma</option>
              <option>Undergraduate</option>
              <option>Postgraduate</option>
            </select>
            {errors.education && <p className="error">{errors.education}</p>}

            {/* Checkbox */}
            <label className="checkbox-row">
              <input
                type="checkbox"
                name="agreed"
                checked={formData.agreed}
                onChange={handleChange}
              />
              <span>I have filled the correct info and agree to the T&C</span>
            </label>
            {errors.agreed && <p className="error">{errors.agreed}</p>}

            {/* Submit */}
            <button className="submit-btn" onClick={handleSubmit}>
              Submit
            </button>

            {/* Status */}
            {submitStatus === "success" && (
              <p className="status success">
                Submitted Successfully ✔. Our team will reach out you.
              </p>
            )}
          </div>
        </div>
      )}

      {/* CONFIRM POPUP */}
      {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <h3>Confirm Submission?</h3>
            <div className="confirm-buttons">
              <button className="yes" onClick={confirmSubmit}>
                Yes
              </button>
              <button className="no" onClick={() => setShowConfirm(false)}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EnrollModal;
